<template>
  <ion-page>
    <master-layout pageTitle="ضایعات">
      <ion-card>
        <ion-card-content>
          <router-link to="/AutoWastage/Add" >
            <ion-button color="success">
              افزودن
            </ion-button>
          </router-link>
          <DataTable auto-reload="1" :headers="headers" route="AutoWastage/listAjax"></DataTable>
        </ion-card-content>
      </ion-card>
    </master-layout>
  </ion-page>
</template>

<script>
import DataTable from "@/components/DataTable";
import {
  IonCard, IonCardContent, IonPage
} from "@ionic/vue";

export default {
  data()
  {
    return {
      id:null,
      headers:[
        'عنوان',
        'مقدار',
        'واحد',
        'امکانات'
      ]
    };
  },
  async created()
  {
    this.id = this.$route.params.id;
  },
  components: {
    IonCard, IonCardContent, DataTable, IonPage
  }
};
</script>

<style scoped>

</style>